import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const PermissionsContext = createContext(null);

// Returns { perms, can, loading }
// can(moduleKey, action) → bool   (action = 'view'|'create'|'update'|'delete')
// Platform roles (super_admin, platform_support) always return true.
export function usePermissions() {
  return useContext(PermissionsContext) || { perms: {}, can: () => true, loading: false };
}

export function PermissionsProvider({ user, children }) {
  const [perms, setPerms] = useState({});
  const [loading, setLoading] = useState(true);

  const isPlatform = user?.role === "super_admin" || user?.role === "platform_support";

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    if (isPlatform) { setLoading(false); return; } // platform = all access, skip fetch
    api.get("/me/permissions")
      .then((r) => setPerms(r.data || {}))
      .catch(() => setPerms({}))
      .finally(() => setLoading(false));
  }, [user?.role]);

  function can(moduleKey, action) {
    if (isPlatform) return true;
    const actionKey = `can_${action}`;
    return perms[moduleKey]?.[actionKey] ?? false;
  }

  return (
    <PermissionsContext.Provider value={{ perms, can, loading }}>
      {children}
    </PermissionsContext.Provider>
  );
}
